module.exports = __webpack_public_path__ + "static/img/20231208_01.799331b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/2023/20231208_01.png
// module id = DFQA
// module chunks = 0